import React, { useState, useCallback, useEffect } from "react";
import { Plus, RefreshCw } from "lucide-react";

import AdminLayout from "@/components/Admin/Layout/AdminLayout";

export default function RoleManagementPage() {
  return (
    <AdminLayout>
      <div className="flex flex-col px-6 py-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Role Management</h1>
            <p className="text-sm text-slate-500">Define roles and control access permissions</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              className="p-2 rounded-lg bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
              title="Refresh"
            >
              <RefreshCw size={16} />
            </button>
            <button
              className="px-3 py-2 bg-[#232F3E] text-white rounded-lg hover:bg-[#37475A] flex items-center gap-1.5 text-sm font-medium transition-colors"
            >
              <Plus size={18} />
              Add New Role
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-slate-200 p-8 text-center text-slate-500">
          <p>Role management view coming soon.</p>
        </div>
      </div>
    </AdminLayout>
  );
}
